<template>
    <div id="footer" class="footer tc f5 w-100">
        <div v-if="!mobile" class="desktop fw4">
            <div class="fl w-30-ns"><a :href="info.tel" class="dim black link"> {{info.num}} </a> </div>
            <div class="fl tracked w-40 f4">
                <div>All<span class="red">on</span> Construction</div>
                <div class="pa2 reah"><a class="link black" href="https://reah.me">website by <span class="red">reah</span></a></div>
            </div>
            <div class="fl w-30">
                <div class="dt tc center">
                    <div class="dtc v-mid"><a class="red link" :href="info.link" target="_blank">{{info.lic}}</a></div>
                </div>
            </div>
        </div>
        <div class="fw4" v-else>
            <div class=" tracked pa1 f4">All<span class="red">on</span> Construction</div>
            <div class="pa1">
                <div class="dt tc center mb2">
                    <div class="dtc v-mid"><a :href="info.tel" class="dim black link">{{info.num}}</a> | <a class="red link" :href="info.link" target="_blank"> {{info.lic}} </a></div>
                </div>
                <div class="pa2 reah"><a class="link black" href="https://reah.me">website by <span class="red">reah</span></a></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Footer',
    props: ['site', 'info', 'mobile']
}
</script>

<style scoped>
.reah {
    font-size: .75rem;
    font-weight: bold;
    letter-spacing: 0;
}
.reah:hover {
    cursor: pointer;
}
</style>